module.exports = __webpack_public_path__ + "static/media/banner.2fb01f9f.png";